/**
 * Search with AJAX
 */

turre_search = function(input, form, autocomplete_container) {

  if (!input || !form || !autocomplete_container) {
    return;
  }

  var search_timeout;

  /**
   * Submit handler
   */
   var turre_submit_handler = function() {

    document.body.classList.add('search-started');

    autocomplete_container.innerHTML = '<div class="spinner"></span>';

    var value = input.value;

    var url = '/?s=' + value;

    axios.get(url)
      .then(function (response) {

        /**
         * Parse response into HTML DOM
         */
        var parser = new DOMParser();
        var html = parser.parseFromString(response.data, "text/html");

        var items = html.querySelectorAll('.search-item');
        if (items.length) {
          autocomplete_container.innerHTML = '';
          for (var i = items.length - 1; i >= 0; i--) {
            autocomplete_container.innerHTML += items[i].outerHTML;
          }
        }

      })
      .catch(function (error) {
        console.log(error);
      });

   }

  /**
   * Catch submit
   */
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    turre_submit_handler();
  });

  /**
   * Trigger submit when typing
   */
  input.addEventListener('input', function(){

    if (input.value === '') {
      form.classList.add('form--no-value');
      form.classList.remove('form--has-value');
    } else {
      form.classList.remove('form--no-value');
      form.classList.add('form--has-value');
    }

    if (search_timeout != null) {
      clearTimeout(search_timeout);
    }
    search_timeout = setTimeout(function() {
      turre_submit_handler();
    }, 1000);
  });

  // make the call chainable
  return this;
};
